export default __webpack_public_path__ + "static/media/schneider5.76d8ab18.png";